const apiEndpoint = 'https://dev-igienair-api.staging.stonecode.io/';
// const apiEndpoint = 'https://demo-igienair-api.staging.stonecode.io/';
// const apiEndpoint = 'https://igienair-api.docker.localhost/';
// const apiEndpoint = 'https://demo-igienair-api.demo.wcentric.com/';
// const apiEndpoint = 'https://preproduction-igienair-api.staging.stonecode.io/';
// const apiEndpoint = 'https://apiv2.qhs.fr/';

/* eslint-disable sort-keys */
if (!window.APP_CONFIG) {
	window.APP_CONFIG = {
		services: [
			{
				'@id': 'auditer',
				'@type': 'service',
				'@urn': '$:registry:service:auditer',
				'id': 'auditer',
				'name': 'Auditer',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'auditer',
				},
			},
			{
				'@id': 'partition',
				'@type': 'service',
				'@urn': '$:registry:service:partition',
				'id': 'partition',
				'name': 'Partitions',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'partition',
				},
			},
			{
				'@id': 'rh',
				'@type': 'service',
				'@urn': '$:registry:service:rh',
				'id': 'rh',
				'name': 'RH',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'rh',
				},
			},
			{
				'@id': 'vehicle',
				'@type': 'service',
				'@urn': '$:registry:service:vehicle',
				'id': 'vehicle',
				'name': 'Véhicules',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'vehicle',
				},
			},
			{
				'@id': 'directory',
				'@type': 'service',
				'@urn': '$:registry:service:directory',
				'id': 'directory',
				'name': 'Annuaire',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'directory',
				},
			},
			{
				'@id': 'sales',
				'@type': 'service',
				'@urn': '$:registry:service:sales',
				'id': 'sales',
				'name': 'Ventes',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'sales',
				},
			},
			{
				'@id': 'intervention',
				'@type': 'service',
				'@urn': '$:registry:service:intervention',
				'id': 'intervention',
				'name': 'Intervention',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'intervention',
				},
			},
			{
				'@id': 'invoice',
				'@type': 'service',
				'@urn': '$:registry:service:invoice',
				'id': 'invoice',
				'name': 'Facturation',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'invoice',
				},
			},
			{
				'@id': 'mercure',
				'@type': 'service',
				'@urn': '$:registry:service:mercure',
				'id': 'mercure',
				'name': 'Mercure',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + '.well-known',
				},
			},
			{
				'@id': 'notification',
				'@type': 'service',
				'@urn': '$:registry:service:notification',
				'id': 'notification',
				'name': 'Notifications',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'notification',
				},
			},
			{
				'@id': 'rights',
				'@type': 'service',
				'@urn': '$:registry:service:rights',
				'id': 'rights',
				'name': 'Droits',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'rights',
				},
			},
			{
				'@id': 'comment',
				'@type': 'service',
				'@urn': '$:registry:service:comment',
				'id': 'comment',
				'name': 'Commentaires',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'comment',
				},
			},
			{
				'@id': 'supplier',
				'@type': 'service',
				'@urn': '$:registry:service:supplier',
				'id': 'supplier',
				'name': 'Fournisseurs',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'supplier',
				},
			},
			{
				'@id': 'file',
				'@type': 'service',
				'@urn': '$:registry:service:file',
				'id': 'file',
				'name': 'Fichiers',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'file',
				},
			},
			{
				'@id': 'analytics',
				'@type': 'service',
				'@urn': '$:registry:service:analytics',
				'id': 'analytics',
				'name': 'Analytics',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'analytics',
				},
			},
			{
				'@id': 'export',
				'@type': 'service',
				'@urn': '$:registry:service:export',
				'id': 'export',
				'name': 'Export',
				'description': '',
				'configurations': {
					'api_endpoint': apiEndpoint + 'export',
				},
			},
		],
	};
}

const AppConfig = window.APP_CONFIG;

export default AppConfig;